import * as React from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";

const styles = {
    border: "0.0625rem solid #9c9c9c",
    borderRadius: "0.25rem",
    width: "100%",
};

export const PlatformCanvasDrawer = forwardRef((props, ref) => {
    const [backgroundImage] = useState(
        `${process.env.PUBLIC_URL}/platform_2x.png`,
    );
    const [canvasWidth, setCanvasWidth] = useState(0);
    const [canvasHeight, setCanvasHeight] = useState(300);
    const containerRef = useRef(null);
    const canvasRef = useRef(null);

    // Handle responsive sizing
    useEffect(() => {
        const updateCanvasSize = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth;
                setCanvasWidth(containerWidth);
                
                // Adjust height proportionally if needed
                // Standard aspect ratio is 1250:300, so height should be containerWidth * (300/1250)
                const aspectRatio = 300 / 1250;
                setCanvasHeight(containerWidth * aspectRatio);
            }
        };

        // Set initial size
        updateCanvasSize();
        
        // Update on window resize
        window.addEventListener('resize', updateCanvasSize);
        
        return () => {
            window.removeEventListener('resize', updateCanvasSize);
        };
    }, []);

    useImperativeHandle(ref, () => ({
        exportImage: () => {
            if (canvasRef.current) {
                // Use the current canvas dimensions for export
                return canvasRef.current.exportImage('png', {
                    width: canvasWidth,
                    height: canvasHeight
                });
            }
        },
        undo: () => {
            if (canvasRef.current) {
                canvasRef.current.undo();
            }
        },
        erase: () => {
            if (canvasRef.current) {
                canvasRef.current.clearCanvas();
            }
        }
    }));

    return (
        <div ref={containerRef} className="w-full">
            {canvasWidth > 0 && (
                <div className="canvas-container">
                    <ReactSketchCanvas
                        height={canvasHeight}
                        width={canvasWidth}
                        ref={canvasRef}
                        style={styles}
                        strokeWidth={2}
                        strokeColor="black"
                        backgroundImage={backgroundImage}
                        exportWithBackgroundImage={true}
                        preserveBackgroundImageAspectRatio="xMidYMid meet"
                    />
                    <div className="flex justify-center space-x-4 mt-3">
                        <button 
                            type="button" 
                            className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm"
                            onClick={() => ref.current.undo()}
                        >
                            Undo Last Stroke
                        </button>
                        <button 
                            type="button" 
                            className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 text-sm"
                            onClick={() => ref.current.erase()}
                        >
                            Clear Canvas
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
});